import React, { createContext, useState, useEffect, useContext } from 'react'
import Cookies from 'js-cookie'

const CVContext = createContext()

export const CVProvider = ({ children }) => {
  const [isCVUploaded, setIsCVUploaded] = useState(() => {
    const cookieValue = Cookies.get('isCVUploaded')
    return cookieValue === 'true' ? true : false
  })

  useEffect(() => {
    Cookies.set('isCVUploaded', isCVUploaded)
  }, [isCVUploaded])

  return (
    <CVContext.Provider value={{ isCVUploaded, setIsCVUploaded }}>
      {children}
    </CVContext.Provider>
  )
}

export const useCV = () => useContext(CVContext)
